import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/admin/delegations',
}).lazy(() => import('./delegations.lazy').then((d) => d.Route))
